import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=212a9136&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=212a9136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a9136",
  null
  
)

export default component.exports